// extracted by mini-css-extract-plugin
module.exports = {"c-sms-form-store-button":"_025a50318d--c-sms-form-store-button--Rebn2","c-apple-btn":"_025a50318d--c-apple-btn--JWeug","c-google-btn":"_025a50318d--c-google-btn--LqpWn"};